import React, { useEffect, useState, createElement } from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { WhatIBelieve } from './components/WhatIBelieve';
import { CaseStudies } from './components/CaseStudies';
import { About } from './components/About';
import { Writing } from './components/Writing';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { CaseStudyPage } from './components/CaseStudyPage';
function setMeta(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"], meta[name="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    if (property.startsWith('og:') || property.startsWith('article:')) {
      el.setAttribute('property', property);
    } else {
      el.setAttribute('name', property);
    }
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const handleHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  useEffect(() => {
    const title = 'Karan Dhir | Marketing Measurement and Decision Systems';
    const description = 'I build the measurement and decision systems that make marketing AI trustworthy enough to act on, built on MMM, incrementality, and causal inference. Owner of a $1.2B+ marketing mix model across 17+ brands.';
    const url = window.location.href;
    document.title = title;
    // Standard SEO
    setMeta('description', description);
    setMeta('author', 'Karan Dhir');
    // Open Graph (LinkedIn, Slack, Facebook)
    setMeta('og:title', title);
    setMeta('og:description', description);
    setMeta('og:type', 'website');
    setMeta('og:url', url);
    setMeta('og:site_name', 'Karan Dhir');
    // Twitter Card
    setMeta('twitter:card', 'summary');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
  }, []);
  const isCaseStudyRoute = hash.startsWith('#/case-study/');
  const caseStudySlug = isCaseStudyRoute ? hash.replace('#/case-study/', '') : null;
  return <div className="min-h-screen bg-dark text-primary font-sans selection:bg-gold/30 selection:text-primary" data-id="element-0">
      <Navigation data-id="element-1" />

      {isCaseStudyRoute && caseStudySlug ? <CaseStudyPage slug={caseStudySlug} data-id="element-2" /> : <main data-id="element-3">
          <HeroSection data-id="element-4" />
          <WhatIBelieve data-id="element-5" />
          <CaseStudies data-id="element-6" />
          <About data-id="element-7" />
          <Writing data-id="element-8" />
          <Contact data-id="element-9" />
        </main>}

      <Footer data-id="element-10" />
    </div>;
}